import { defineComponent as _defineComponent } from 'vue'
import Cleave from "vue-cleave-component";
  import { reactive, computed, onMounted, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { required, email } from "@vuelidate/validators";
  import { validPhoneNumber } from "@/helpers/validation";
  import store from "@/store";
  import router from "@/router";
  import { UserInterface } from "@/types/UserInterface";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { useRoute } from "vue-router";
  import { UserTier } from "@/enums/UserTier";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminUserUpdate',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId;
  const form = reactive<Partial<UserInterface>>({
    firstName: "",
    middleName: "",
    lastName: "",
    phone: "",
    tier: UserTier.OFF,
  });
  const emailField = ref("");
  const user = ref<UserInterface | null>(null);
  const rules = computed(() => {
    return {
      form: {
        firstName: { required, $autoDirty: true },
        lastName: { required, $autoDirty: true },
        phone: { validPhoneNumber, $autoDirty: true },
        tier: { required, $autoDirty: true },
      },
      emailField: { required, email, $autoDirty: true },
    };
  });
  const v$ = useVuelidate(rules, { form, emailField });
  const emailError = ref("");
  const route = useRoute();

  onMounted(() => {
    store.dispatch("user/getUser", userId).then((res) => {
      form.firstName = res.data.firstName;
      form.middleName = res.data.middleName;
      form.lastName = res.data.lastName;
      form.phone = res.data.phone;
      emailField.value = res.data.email;
      user.value = res.data;
      form.tier = res.data.tier || UserTier.OFF;
    });
  });

  const updateUser = async () => {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    if (user.value?.email !== emailField.value.toLowerCase()) {
      const { status } = await store
        .dispatch("user/updateUserEmail", {
          id: userId,
          data: { email: emailField.value.toLowerCase() },
        })
        .catch((error) => {
          if (error.response.data.message) {
            emailError.value = error.response.data.message;
          }
        });

      if (status !== 200) {
        return;
      }
    }

    const data = {
      id: userId,
      data: form,
    };

    store.dispatch("user/updateUser", data).then(() => {
      router.push({
        name:
          router.currentRoute.value.name === "AdminUserUpdate"
            ? "AdminUser"
            : "AdminLawyer",
        params: { userId },
      });
    });
  };

const __returned__ = { userId, form, emailField, user, rules, v$, emailError, route, updateUser, get Cleave() { return Cleave }, reactive, computed, onMounted, ref, get useVuelidate() { return useVuelidate }, get required() { return required }, get email() { return email }, get validPhoneNumber() { return validPhoneNumber }, get store() { return store }, get router() { return router }, get UserInterface() { return UserInterface }, get phoneNumberOption() { return phoneNumberOption }, get useRoute() { return useRoute }, get UserTier() { return UserTier } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})